export const fetchProjects = async () => {
    const data = await fetch(`https://tusharkandpal.github.io/data/projects.json`, {
        headers: {
            "Accept": "application/json",
        },
    })

    const result = await data.json();
    return result;
}




